import Text from "../../Components/Text/Text";
import { ReactComponent as LeftTriangleSvg } from "../../assets/svgs/left-triangle.svg";
import { ReactComponent as RightTriangleSvg } from "../../assets/svgs/right-triangle.svg";
import RadicalClarityImg from '../../assets/images/home/radical-clarity.png'
import RiskManagementImg from '../../assets/images/home/risk-management.png'
import StakeholderImg from '../../assets/images/home/stakeholder.png'
import TechnicalExcellenceImg from '../../assets/images/home/technical-excellence.png'
import { useRef, useState, useEffect } from "react";
import { useWindowScroll } from "../../hooks/useWindowScroll";

const percentageData = [
  {
    percentage: 37,
    description: "of software projects fail due to",
    reason: "Unclear Goals",
  },
  {
    percentage: 23,
    description: "of failures stem from",
    reason: "Ineffective Risk Management",
  },
  {
    percentage: 25,
    description: "of projects struggle due to",
    reason: "Poor Stakeholder Engagement",
  },
]

const stategyData = [
  {
    src: RadicalClarityImg,
    title: 'Radical Clarity',
    description: "Every project starts with well-defined goals, measurable outcomes, and risk mitigation strategies.",
  },
  {
    src: RiskManagementImg,
    title: 'Strategic Risk Management',
    description: "We identify, assess, and address potential pitfalls before they become problems.",
  },
  {
    src: StakeholderImg,
    title: 'Stakeholder-Centric Execution',
    description: "Engaging key decision-makers throughout the process ensures alignment and success.",
  },
  {
    src: TechnicalExcellenceImg,
    title: 'Technical Excellence',
    description: "Our engineers build for long-term scalability and maintainability.",
  },
]

export function RenderPercentageContent ({ item, index, show }) {
  const [active, setActive] = useState(false);
  const [count, setCount] = useState(0);
  
  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  useEffect(() => {
    let id;
    if (show && count < item.percentage) {
      id = setInterval(() => {
        setCount(count + 1);
      }, 20);
    } else {
      id && clearInterval(id);
    }
    return () => id && clearInterval(id);
  }, [show, item, count]);
  return (
    <div
      className={`flex-1 relative transition-all duration-700 delay-150 ${
        active ? "" : "opacity-0 translate-y-96"
      }`}
    >
      <span className="absolute left-0 top-0 w-2.5 max-md:w-1.5 h-full bg-black" />
      <div className='p-10 max-sm:py-6'>
        <Text type="h1" size="d6" className="mb-3 text-grey-950">{count}%</Text>
        <Text type="p" size="bodyXl" className="mb-3">
          {item.description}
        </Text>
        <Text type="p" size="d2" className="text-red-500 text-balance max-w-[250px] max-md:max-w-full max- font-bold">
          {item.reason}
        </Text>
      </div>
    </div>
  )
}

export function RenderStrategyContent ({ item, index, show }) {
  const [active2, setActive2] = useState(false);
  
  useEffect(() => {
    const time = show ? index * 300 : 0;
    const timeId = setTimeout(() => setActive2(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <div className={`transition-all duration-700 delay-150 ${
        active2 ? "" : "opacity-0 translate-y-96"}`}>
      <img src={item.src} alt={item.title} className="mb-6" />
      <Text type="h1" size="d2" className="mb-6 font-bold min-h-[64px] max-sm:min-h-0">{item.title}</Text>
      <Text type="p" size="bodyXl" className="mb-3">
        {item.description}
      </Text>
    </div>
  )
}

export default function EliminateSoftwareSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();
  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 2;
  const show = y > boundary;
  
  return (
    <div className="bg-grey-200 relative" ref={ref}>
      <LeftTriangleSvg className="transition-all absolute top-0 fill-white animate-raise-up w-full" />
      <div className="mx-auto container px-4 py-[320px] max-sm:py-[120px]">
        <Text 
          type="h1" 
          size="d5" 
          className={`mb-[120px] max-sm:mb-[60px] transition-all duration-700 text-grey-950 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >Eliminate Software Failure Before It Starts</Text>
        <Text type="h1" size="subD5" className={`mb-16 transition-all duration-700 ${show ? "" : "opacity-0 translate-y-96"}`}>The Reality of Software Failure</Text>
        <div className="flex mb-[120px] max-md:flex-col max-md:gap-6 max-sm:mb-[60px]" >
          {
            percentageData.map((item, index) => (<RenderPercentageContent key={index} item={item} show={show} />))
          }
        </div>
        <Text type="h1" size="subD5" className={`mb-16 transition-all duration-700 delay-150 ${show ? "" : "opacity-0 translate-y-96"}`}>Strategy for Project Success</Text>
        <div className="grid max-sm:!grid-cols-1 max-md:grid-cols-2 grid-cols-4 gap-16 mt-10">
          {
            stategyData.map((item, index) => (<RenderStrategyContent key={index} item={item} show={show} />))
          }
        </div>
      </div>
      <RightTriangleSvg className="transition-all absolute bottom-0 fill-white animate-raise-up w-full" />
    </div>
  );
}